var $ = require('jquery');

(function () {

    /**
     * helper function to determining if the user is editing (has editing layers open)
     */
    this.isEditing = function () {
        var editing = CC.EmotionHeader.isOpen() ||
                window.Modul.getActiveModule() ||
                jQuery(':diy-confirmationDialog:visible').length
            ;
        return editing;
    };

    /**
     * return the bodys page id if set
     *
     * @returns {*|jQuery}
     */
    this.getCurrentPageId = function() {
        return $(document.body).attr('data-pageid')
    };

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/page/page.js
 ** module id = 719
 ** module chunks = 0
 **/